import { render, staticRenderFns } from "./AddService.vue?vue&type=template&id=586c8a6f&"
import script from "./AddService.vue?vue&type=script&lang=js&"
export * from "./AddService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports